import React from "react";
import CandidateSubNav from "../pages/Candidate/components/CandidateSubNav";
import { Outlet, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCandidateForm } from "../pages/Candidate/CandidateFormContext";

// All navigation items - shown in edit mode
const allNavArr = [
  {
    name: "Personal",
    link: "personal",
  },
  {
    name: "Notes",
    link: "notes",
  },
  {
    name: "Marketing",
    link: "marketing",
  },
  {
    name: "Interviews",
    link: "interviews",
  },
  {
    name: "Projects",
    link: "projects",
  },
  {
    name: "Trainings",
    link: "trainings",
  },
  {
    name: "Documents",
    link: "documents",
  },
];

// Create mode only shows Personal section
const createModeNavArr = [
  {
    name: "Personal",
    link: "personal",
  },
];

const CandidateLayout = ({ children }) => {
  const candidateId = useSelector(state => state.personal.candidateId);
  const basic = useSelector(state => state.personal.basic);
  const { isCreating } = useCandidateForm();

  return (
    <div className="p-5">
      <div className="w-full h-10 justify-between items-center inline-flex my-3">
        <div className="justify-start items-center gap-2 flex">
          <Link
            to="/candidate"
            className="text-neutral-700 text-base font-medium font-['poppins'] tracking-tight hover:text-primary-500 cursor-pointer transition-colors"
          >
            Candidate
          </Link>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="icon">
              <path
                id="Vector 9"
                d="M16 3.00195L7 12.002L16 21.002"
                stroke="#6E6E6E"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </g>
          </svg>
          <div className="text-slate-700 text-base font-medium font-['Inter'] tracking-tight">
            {isCreating ? 'Add Candidate' : `${basic.firstName || ''} ${basic.lastName || ''}`.trim() || 'Edit Candidate'}
          </div>
        </div>
        <div className="w-[287px] px-4 justify-start items-center gap-4 flex">
          <div className="flex-col justify-center items-start inline-flex">
            <div className="text-center text-neutral-500 text-sm font-normal  leading-tight tracking-tight">
              Trainee
            </div>
            <div className="text-center text-stone-300 text-xs font-normal  leading-none">
              Type{" "}
            </div>
          </div>
          <div className="w-px self-stretch py-4 flex-col justify-start items-center inline-flex">
            <div className="w-2 grow shrink basis-0 origin-top-left rotate-90 border border-stone-300"></div>
          </div>
          <div className="flex-col justify-center items-start inline-flex">
            <div className="text-center text-neutral-500 text-sm font-normal  leading-tight tracking-tight">
              Inactive
            </div>
            <div className="text-center text-stone-300 text-xs font-normal  leading-none">
              Status
            </div>
          </div>
          <div className="w-px self-stretch py-4 flex-col justify-start items-center inline-flex">
            <div className="w-2 grow shrink basis-0 origin-top-left rotate-90 border border-stone-300"></div>
          </div>
          <div className="flex-col justify-center items-start inline-flex">
            <div className="text-center text-neutral-500 text-sm font-normal  leading-tight tracking-tight">
              Kelly Martin
            </div>
            <div className="text-center text-stone-300 text-xs font-normal  leading-none">
              Owner
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-9 border-b border-stone-300 flex gap-12 items-start">
        {/* Show only Personal in create mode, all sections in edit mode */}
        {(isCreating ? createModeNavArr : allNavArr).map(({ name, link }) => (
          <CandidateSubNav key={link} name={name} link={link} />
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export default CandidateLayout;
